import { orderStatuses } from '@/entities/insurance/config';
import { DateFormatter } from '@/shared/lib/calendar';

export const PetsOrderParamsMapper = () => {
  const { formatTimestamp } = DateFormatter();

  const parseFullNameToPartsUa = (fullName) => {
    if (!fullName || typeof fullName !== 'string') return ['', '', ''];

    const nameParts = fullName.split(' ').filter(Boolean);

    if (nameParts.length >= 3) {
      return [nameParts[0] || '', nameParts[1] || '', nameParts.slice(2).join(' ') || ''];
    } else if (nameParts.length === 2) {
      return [nameParts[0] || '', nameParts[1] || '', ''];
    } else if (nameParts.length === 1) {
      return [nameParts[0] || '', '', ''];
    }

    return ['', '', ''];
  };

  const preparePetsOrderDraft = ({
    petType,
    petBreed,
    petSex,
    petAlias,
    petBirthDate,
    vetPassportSerial,
    vetPassportNumber,
    vetPassportDate,
    vetPassportIssuedBy,
    microchipCode,
    microchipDate,
    insurancePeriod,
    earnings,
    startDate,
    policyholder,
    document,
    offerInfo,
    orderId,
    statusId = orderStatuses.DRAFT,
  }) => {
    const nameParts = policyholder?.fullName?.partsUa?.length
      ? policyholder.fullName.partsUa
      : parseFullNameToPartsUa(policyholder?.fullName?.fullNameUa);

    const orderDraft = {
      clientId: policyholder?.id || null,
      petType,
      petBreed,
      petSex,
      petAlias,
      petBirthDate: formatTimestamp(petBirthDate),
      vetPassportSerial,
      vetPassportNumber,
      vetPassportDate: formatTimestamp(vetPassportDate),
      vetPassportIssuedBy,
      microchipCode,
      microchipDate: formatTimestamp(microchipDate),
      insurancePeriod,
      earnings,
      startDate: formatTimestamp(startDate),
      statusId,
      allowedDocuments: offerInfo?.allowedDocuments || null,
      earningsParam: earnings ?? null,
      price: offerInfo?.price || null,
      offerId: offerInfo?.offerId || offerInfo?.id || null,
      info: {
        name_ua: nameParts[1] || null,
        surname_ua: nameParts[0] || null,
        patronymic_ua: nameParts[2] || null,
        dateBirth: formatTimestamp(policyholder?.dateOfBirth),
        phone: policyholder?.phone || null,
        mail: policyholder?.email || null,
        city: policyholder?.address?.city || null,
        street: policyholder?.address?.street?.nameUa || null,
        house: policyholder?.address?.buildingNumber || null,
        apartment: policyholder?.address?.apartmentNumber || null,
        identificationCode: policyholder?.taxNumber || null,
        withoutIdentificationCode: policyholder?.withoutTaxNumber || false,
      },
      offerInfo,
    };

    if (orderId) {
      orderDraft.orderId = orderId;
    }

    if (document) {
      orderDraft.info.documentation = {
        type: document.type?.id ?? document.type ?? null,
        serial: document.serialNumber || null,
        number: document.number || null,
        dateOfIssue: formatTimestamp(document.issueDate),
        endDateOfIssue: formatTimestamp(document.expirationDate),
        issuedBy: document.issuingAuthority || null,
      };
    }

    return orderDraft;
  };

  return {
    preparePetsOrderDraft,
  };
};